export enum Skill {
  completion = 'completion',
  docCompletion = 'doc_completion',
  sowPredictor = 'sow_predictor',
}
